import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section className="py-24 px-4 bg-black" data-id="element-178">
      <div className="max-w-3xl mx-auto" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-180">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-181">
            ¿Te suena conocido esto?
          </h2>
          <p className="text-lg text-gray-300 leading-relaxed bg-dark-card p-6 rounded-2xl border border-dark-border" data-id="element-182">
            Domingo a las 11 de la noche. Mañana tienes clase de Comunicación y
            Medios. Y todavía estás buscando cómo explicar la diferencia entre
            un meme y desinformación, o cómo hablar de algoritmos sin que tus
            alumnos sientan que es demasiado técnico o que no tiene nada que ver
            con su vida.
            <br data-id="element-183" />
            <br data-id="element-184" />
            <span className="text-gold-light font-medium" data-id="element-185">
              No es tu culpa.
            </span>{' '}
            Es que llevas años peleando con materiales desorganizados, teoría
            densa pensada para otras realidades y recursos de otros países que
            después tenés que reescribir entero para que tenga sentido en tu
            aula.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-186">
          <h3 className="text-xl font-bold text-white mb-8 text-center" data-id="element-187">
            El costo de no tener el material correcto:
          </h3>

          <ul className="space-y-4" data-id="element-188">
            {['Noches en vela buscando cómo traducir conceptos como framing, agenda setting o economía de la atención a un lenguaje que tus alumnos puedan entender', 'Clases improvisadas porque no encontraste un material claro y listo para usar a tiempo', 'Alumnos desconectados que sienten que la comunicación y los medios no tienen nada que ver con ellos ni con lo que viven en las redes todos los días', 'Silencios incómodos cuando un alumno pregunta por qué TikTok le muestra siempre lo mismo o cómo saber si una noticia es falsa y no tenés una respuesta clara a mano', 'Fines de semana perdidos armando planificaciones, actividades y evaluaciones desde cero una y otra vez'].map((point, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 bg-dark-card p-4 rounded-xl border border-red-900/30" data-id="element-189">
                <span className="text-red-500 mt-1" data-id="element-190">🔴</span>
                <span className="text-gray-300" data-id="element-191">{point}</span>
              </motion.li>)}
          </ul>

          <div className="text-center mt-12 pt-8 border-t border-dark-border" data-id="element-192">
            <p className="text-2xl font-serif font-bold text-gold-gradient" data-id="element-193">
              Basta de regalar tu tiempo libre. Tu dedicación ya la tenés. Ahora
              te falta la herramienta.
            </p>
            <p className="text-xl mt-4 text-white" data-id="element-194">
              Planificá todo tu año hoy.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}